import React, { Component } from 'react';


import './assets/css/argon.css?v=1.0.0'
// import './assets/css/argon.min.css'
import './assets/vendor/@fortawesome/fontawesome-free/css/all.min.css'
import './assets/img/brand/favicon.png'
import './assets/vendor/nucleo/css/nucleo.css'
import './assets/css/custom.css'

// import { Dropdown, DropdownButton } from 'react'

import NavigationItems from './Components/NavigationItems'
// import HeaderDashboard from './Components/HeaderDashboard'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'

// import { Link , Redirect} from 'react-router-dom';
// import { Button } from 'react-bootstrap';
import { PieChart } from 'react-minimal-pie-chart';
import { //NotificationContainer,
  NotificationManager
} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import {
  WaveLoading,
  // LoopCircleLoading  
} from 'react-loadingg';

import {
  Link,
  // Redirect
} from 'react-router-dom'
import Base from './Config'
//import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

class Dashboard extends Component {
  constructor(props) {
    super(props)
    const token = localStorage.getItem('Token')
    let loggedIn = true
    if (token == null) {
      loggedIn = false
    }
    this.state = {
      show: false,
      dashboard: {},
      loading: false,
      inspection_charge: 0,
      quotation_charge: 0,
      from_date: "",
      to_date: "",
      loggedIn
    }

    // this.logout = this.logout.bind(this)
  }

  // logout(){
  //   localStorage.removeItem('Token')
  //   this.setState({
  //     loggedIn:false
  //   })
  //   alert('logout sucess')  
  // }

  componentDidMount() {
    // console.log('Dashboard ComponentDidMount');
    // console.log(localStorage.getItem('Token'));
    // return false
    axios.get(
      // Base.url+'PaymentReport/?keyword=sum_of_payment&from_date=01/01/20 10:30:00&to_date=7/02/20 00:00:00',
      Base.url + 'PaymentReport/?keyword=sum_of_payment',
      {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    ).then(responseRev => {
      // console.log('Response :',responseRev.data);
      axios.get(
        Base.url + 'AdminDashboard/',
        {
          headers: {
            'Authorization': 'Token ' + localStorage.getItem('Token'),
          }
        }
      ).then(response => {
        // console.log('Response :',response.data);
        // console.log('Response :',response.data['total_orders']);
        this.setState({
          inspection_charge: responseRev.data['inspection_charge'],
          quotation_charge: responseRev.data['quotation_charge'],
          dashboard: response.data,
          loading: false
        })
      })
        .catch(error => {
          console.log('Error : ', error);
          // NotificationManager.error('Error : ', error, 3000);
          NotificationManager.error('Error message', error, 5000)
        })
    })
      .catch(error => {
        console.log('Error : ', error);
        NotificationManager.error('Error message', error, 5000)
        // NotificationManager.error('Error : ', error, 3000);
      })
  }

  onChange = (e) => {
    console.log('worked :' + [e.target.name] + " : " + e.target.value);

    this.setState({
      [e.target.name]: e.target.value
    }, () => {
      if (this.state.from_date && this.state.to_date) {
        console.log('Revenue calculated');
        this.calcRevenue()
      }
    })
  }


  calcRevenue = () => {

    // console.log(this.state.from_date)
    // console.log(this.state.to_date)

    axios.get(
      Base.url + 'PaymentReport/?keyword=sum_of_payment&from_date=' + this.state.from_date + ' 00:00:0' + '&to_date=' + this.state.to_date + ' 00:00:0',
      {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('Token'),
        }
      }
    ).then(responseRev => {
      // console.log('Response :',responseRev.data);
      this.setState({
        inspection_charge: responseRev.data.inspection_charge,
        quotation_charge: responseRev.data.quotation_charge
      })
    })
      .catch(error => {
        console.log('Error : ', error);
        // NotificationManager.error('Error : ', error, 3000);
        NotificationManager.error('Error message', error, 5000)

      })

  }


  render() {
    // if(this.state.loggedIn === false){
    //   alert('please login first')
    //   return <Redirect to='/login'/>
    // }
    console.log((this.state.dashboard))

    if (this.state.loading) {
      return (
        <div>
          <NavigationItems />
          {/* Main content */}
          <div className="main-content">
            <PageHeader />
            <div className="header bg-gradient-primary pb-8 pt-5 pt-md-6">
              <div className="container-fluid">
                <div className="header-body">
                  {/* Card stats */}
                  <div className="row">
                    <div className="col-xl-6 col-lg-6">
                      <div className="card card-stats mb-5 mb-xl-0">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                              <span className=" font-weight-bold mb-0">Hi, You have</span>
                            </div>
                          </div>
                          <WaveLoading />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                      <div className="card card-stats mb-5 mb-xl-0">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                              <span className=" font-weight-bold mb-0">Users</span>
                            </div>
                          </div>
                          <WaveLoading />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content */}
            <div className="container-fluid mt--7">
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="card card-stats mb-5 mb-xl-0">
                    <div className="card-body">
                      <div className="row">
                        <div className="col">
                          {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                          <span className=" font-weight-bold mb-0">Revenue</span>
                        </div>
                      </div>
                      <WaveLoading />
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 mb-10">
                  <div className="card shadow">
                    <div className="card-header bg-transparent">
                      <div className="row align-items-center">
                        <div className="col">
                          <h6 className="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                          <WaveLoading />
                        </div>
                      </div>
                    </div>
                    <div />
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      )
    } else {
      // console.log('loading');
      return (
        <div>
          <NavigationItems />
          {/* Main content */}
          <div className="main-content">
            <PageHeader pageName={'Dashboard'} />
            <div className="header bg-gradient-primary pb-8 pt-5 pt-md-6">
              <div className="container-fluid">
                <div className="header-body">
                  {/* Card stats */}

                  <div className="row">
                    <div className="col-xl-3 col-lg-6">
                      <div className="card card-stats mb-5 mb-xl-0">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                              <span className=" font-weight-bold mb-0">Hi, You have</span>
                            </div>
                          </div>

                          <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-success mr-2" style={{ fontSize: 20, fontWeight: 'bold' }}>
                              {this.state.dashboard['total_orders'] ? this.state.dashboard['total_orders'] : 0}
                            </span>

                            <Link to="/orders" className="text-nowrap">Orders</Link>
                            <span className="text-red mr-2" style={{ paddingLeft: 10, fontSize: 15 }}>
                              {this.state.dashboard['new orders'] > 0 ? ("(" + this.state.dashboard['new orders'] + " New )") : ''}
                            </span>
                          </p>

                          <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-blue mr-2" style={{ fontSize: 20, fontWeight: 'bold' }}>
                              {this.state.dashboard['total_qtns']} </span><Link to="/quotation" className="text-nowrap">Quotaions</Link>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-6">
                      <div className="card card-stats mb-5 mb-xl-0">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                              <span className=" font-weight-bold mb-0">Users</span>
                            </div>

                          </div>

                          <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-success mr-2" style={{ fontSize: 20, fontWeight: 'bold' }}>
                              {this.state.dashboard['tenents_count'] ? this.state.dashboard['tenents_count'] : '0'}
                            </span>
                            <Link to="/users" className="text-nowrap">Tenants</Link>
                          </p>
                          <p className="mt-3 mb-0 text-muted text-sm">
                            <span className="text-blue mr-2" style={{ fontSize: 20, fontWeight: 'bold' }}>
                              {this.state.dashboard['outsider_count'] ? this.state.dashboard['outsider_count'] : '0'}
                            </span>
                            <Link to="/user" className="text-nowrap">Outsiders</Link>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-6">
                      <div className="card card-stats mb-5 mb-xl-0">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                              <span className=" font-weight-bold mb-0">Revenue</span>
                              <table>
                                <thead>
                                  <tr>
                                    <td>
                                      <p className="mt-3 mb-0 text-muted text-sm">
                                        <b>QAR</b> <span className="text-success mr-2" style={{ fontSize: 20, fontWeight: 'bold' }}>{this.state.inspection_charge ? this.state.inspection_charge : 0} </span> <span className="text-nowrap">Inspection</span>
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <p className="mt-3 mb-0 text-muted text-sm">
                                        <b>QAR</b> <span className="text-blue mr-2" style={{ fontSize: 20, fontWeight: 'bold' }}>{this.state.quotation_charge ? this.state.quotation_charge : 0} </span><span className="text-nowrap">Quotaions</span>
                                      </p>
                                    </td>
                                  </tr>
                                </thead>
                              </table>

                            </div>
                            <table>
                              <thead>
                                <tr>
                                  <td>
                                    <p className="mt-3 mb-0 text-muted text-sm">
                                      <b>from date :</b>
                                    </p>
                                    <input className="form form-control" type="date" name="from_date" onChange={this.onChange} /></td>
                                  <td>
                                    {/* <button type="button" className="btn btn-primary mt-4" onClick={this.calcRevenue}>find</button>  */}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p className="mt-3 mb-0 text-muted text-sm">
                                      <b>to date :</b>
                                    </p>

                                    <input className="form form-control" type="date" name="to_date" onChange={this.onChange} /></td>
                                  <td></td>
                                </tr>
                              </thead>
                            </table>
                          </div>




                          {/* <br/> */}




                          {/* new :<input className="form form-control" type="date"></input> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Page content */}
            <div className="container-fluid mt--7">
              <div className="row">



                <div className="col-xl-10 mb-10">
                  <div className="card shadow">
                    <div className="card-header bg-transparent">
                      <div className="row align-items-center">
                        <div className="col">
                          <h6 className="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                          <i className="fa fa-circle text-blue" ></i><label className=" text-sm">Quotation &nbsp;&nbsp; </label>
                          <i className="fa fa-circle text-red" ></i><label className=" text-sm">Pending &nbsp;&nbsp; </label>
                          <i className="fa fa-circle text-yellow" ></i><label className=" text-sm">Scheduled &nbsp;&nbsp; </label>
                          <i className="fa fa-circle text-green" ></i><label className=" text-sm">Completed &nbsp;&nbsp; </label>
                          {
                            (this.state.dashboard['on_qtn'] == 0 & this.state.dashboard['pending_qtn'] == 0 & this.state.dashboard['in_progress_qtn'] == 0) ?
                              <PieChart
                                animate
                                animationDuration={800}
                                animationEasing="ease-in"
                                cx={50}
                                cy={50}
                                data={[
                                  {
                                    color: '#4ecc6f',
                                    title: 'Scheduled: ' + this.state.dashboard['completed_qtn'],
                                    value: this.state.dashboard['completed_qtn'],
                                    // value: 0,
                                  },
                                ]}
                                label={false}
                                labelPosition={50}
                                lengthAngle={360}
                                lineWidth={80}
                                onClick={undefined}
                                onMouseOut={undefined}
                                onMouseOver={undefined}
                                paddingAngle={0}
                                radius={30}
                                rounded={false}
                                startAngle={0}
                                viewBoxSize={[
                                  50,
                                  30
                                ]}
                              />
                              :
                              // <></>
                              // <PieChart
                              //   // data={[
                              //   //   { title: 'One', value: 10, color: '#E38627' },
                              //   //   { title: 'Two', value: 15, color: '#C13C37' },
                              //   //   { title: 'Three', value: 20, color: '#6A2135' },
                              //   // ]}
                              // />
                              <PieChart
                                // animate={true}
                                // animationDuration={800}
                                // animationEasing="ease-in"
                                // cx={50}
                                // cy={50}
                                data={[
                                  {
                                    color: '#5e72e4',
                                    title: 'Quotation: ' + this.state.dashboard['on_qtn'],
                                    value: this.state.dashboard['on_qtn'],
                                  },
                                  {
                                    color: '#f5365c',
                                    title: 'Pending : ' + this.state.dashboard['pending_qtn'],
                                    value: this.state.dashboard['pending_qtn'],
                                  },
                                  {
                                    color: '#ffd600',
                                    title: 'Scheduled: ' + this.state.dashboard['in_progress_qtn'],
                                    value: this.state.dashboard['in_progress_qtn'],
                                  },
                                ]}
                              label={false}
                              labelPosition={50}
                              lengthAngle={360}
                              lineWidth={80}
                              // onClick={undefined}
                              onMouseOut={undefined}
                              // onMouseOver={undefined}
                              paddingAngle={0}
                              radius={30}
                              rounded={false}
                              startAngle={0}
                              // viewBoxSize={[
                              //   50,
                              //   30
                              // ]}
                              />
                          }

                        </div>
                      </div>
                    </div>
                    <div id="piechart" />
                  </div>
                </div>

              </div>
              <Footer />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Dashboard